import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "../../-components/reservation-form";
import { T } from "@/i18n";
import { CalendarRange, Plus } from "lucide-react";

export const Route = createFileRoute(
  "/(reservations)/reservations/calendar/new/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  return (
    <Form
      clients={[]}
      accommodations={[]}
      reservationdays={[]}
      services={[]}
      isLoading={false}
      onSuccess={(id) => {
        navigate({ to: "/reservations/calendar/$id", params: { id } });
      }}
      crumbs={[
        {
          content: (
            <>
              <T tKey="reservations.calendar.title" />{" "}
              <CalendarRange width={16} height={16} />
            </>
          ),
          href: "/reservations/calendar",
        },
        {
          content: (
            <>
              <T tKey="reservations.new.title" />{" "}
              <Plus width={16} height={16} />
            </>
          ),
          href: "/reservations/calendar/new",
        },
      ]}
    />
  );
}
